/**
 * Dizionario di valori che possono governare il comportamento
 * o lo stile di alcuni componenti dell'applicazione
 * 
 * Parte di questi valori viene impostato al momento del login
 * estraendo i dati associati al modello utente (giunto dal server)
 * mentre altri possono essere modificati nella pagina delle impostazioni
 * 
 * Dovrebbero sempre avere dei valori di default
 */
export class PreferenzeApp {
    // ---- PREFERENZE IMPOSTABILI DALL'UTENTE
    MODALITA_SCURA = false;
    /**
     * Se TRUE le anagrafiche vengono lette sempre dal Db,
     * anche quando l'applicazione e' connessa
     */
    USA_SOLO_ANAGRAFICHE_OFFLINE = false;

    // ---- PREFERENZE OTTENUTE AL LOGIN -----
    /**
     * (siglaclie)
     * Identificatore di personalizzazione attiva
     */
    SIGLA_CLIENTE: string;
    /**
     * Legato alla sigla cliente clienti per ora
     */
    LEGGI_ATTIVITA_DA_COMMESSA = false;
    /**
     * (visricambi) se TRUE va mostrata all'utente la possibilità
     * di registrare ricambi legati ad un intervento
     */
    MOSTRA_RICAMBI = true;
    /**
     * Se true (default) gli interventi vengono proposti dall'ultimo
     */
    ORDINE_DECRESCENTE_INTERVENTI = true;
    /**
     * Governa il taglio di minuti specificabile da parte degli operatori
     * sulle diverse attivita'.
     * Ogni valori di minuti scelto, diverso da 0 e minore di 60, deve
     * essere multiplo di questa configurazione.
     * Es. Se vale 15 l'operatore può specificare solo 0, 15, 30,
     * 45 minuti
     */
    MOLTEPLICITA_MINUTI_CONSENTITA = 1;
    /**
     * Governa la visibilità del pulsante aggiungi nuovo intervento.
     * Di default gli operatori non possono creare interventi dall'app
     * @since 2.7.0
     */
    DISABILITA_AGGIUNGI_INTERVENTO = true;
    /**
     * Numero di versione di pacchetto dichiarato da Integra ogni
     * volta che l'utente fa login.
     * Può influenzare le funzionalità disponibili
     */
    VERSIONE_INTEGRA: string;
    /**
     * Coordinate x e y per l'apposizione della firma sul rapportino di intervento.
     * L'origine di riferimento per le coordinate è l'angolo basso sinistro del pdf.
     */
    COORDINATE_FIRMA: {
        x: number,
        y: number
    };

    /**
     * Gestisce visualizzazione delle spese (setup su integra IMTOSPEVI): 
     * se T, spese visualizzate in testata
     * se R, spese visualizzate nelle righe
     * se N, spese non visualizzate
     */
    MOSTRA_SPESE: string;

    /**
     * Se TRUE, nella chiusura intervento sarà obbligatorio inserire una mail
     */
    MAIL_OBB = false;

    /**
     * Se TRUE, nella chiusura intervento saranno preselezionati i destinatari delle mail presenti in contattiCliente
     */
    PRESELEZIONA_DESTINATARI_MAIL = false;

    /**
     * Se 1 nella chiusura intervento il campo relativo alle note sarà chiuso con la possibilità di mostrarlo/nasconderlo.
     * Se 2 nella chiusura intervento il campo relativo alle note sarà nascosto.
     */
    ABILITA_COLLASSO_NOTE: string;
    /**
     * Se 1 sarà possibile modificare la descrizione dei ricambi se anche il prodotto lo permette
     */
    DESCRPROMOD: string;
    /**
     * Se 1 sarà possibile inserire il prezzo di vendita dei ricambi
     */
    PREZZOMOD: string;
    /**
     * Numero decimali consentiti per il prezzo dei ricambi.
     * Default 2.
     */
    NUMDECPREZZOMOD: number = 2;
    /**
     * Stati selezionabili nei filtri degli interventi.
     * Ogni elemento contiene codice e descrizione, separati da ;
     */
    FLTRSTINT: string[] = [];
    /**
     * Configurazione delle transizioni di stato degli interventi ricevuta alla login.
     * Ogni elemento ha il formato:
     * tipoDocumento;statoAttuale;statoDestinazione;etichetta;funzione
     * Il codice destinazione 99 indica che per quella combinazione non è configurato
     * alcuno stato assegnabile; la riga verrà omessa dalle opzioni.
     * La funzione può essere vuota (in questo caso non sarà possibile effettuare
     * il cambio stato); se valorizzata, identifica il comportamento da applicare.
     */
    MTOMVSWKF: string[] = [];
    /**
     * Motivazioni KO selezionabili nel cambio stato degli interventi.
     * Ogni elemento contiene codice e descrizione, separati da ;
     */
    MOTIVOKO: string[] = [];
    /**
     * Se 1 nel bottone "persona" dell'intervento mostra solo telefono ed email;
     * nel bottone "palazzo" mostra solo l'indirizzo.
     * Se non attivo, mantiene la visualizzazione standard
     */
    MODCNTINT: string;

    verificaUguaglianzaEntita() {
        return true; // 1 sola preferenza sul DB, sovrascrivo sempre
    }
}
